import { AiChat } from '../Actions/EnumTypes/ActionEnumTypes';

export interface AiChatItem {
  uuid: string;
  title: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface AiChatMessageItem {
  uuid: string;
  role: 'user' | 'model';
  content: string;
  createdAt: string;
}

export type State = {
  chats: AiChatItem[];
  activeChatUuid: string | null;
  messages: AiChatMessageItem[];
  isStreaming: boolean;
  streamBuffer: string;
  error: string | null;
  isConnected: boolean;
};

export const initialState: State = {
  chats: [],
  activeChatUuid: null,
  messages: [],
  isStreaming: false,
  streamBuffer: '',
  error: null,
  isConnected: false,
};

export function aiChatReducer(state: State = initialState, action: any): State {
  switch (action.type) {
    case AiChat.SET_CONNECTED: {
      return {
        ...state,
        isConnected: action.payload,
      };
    }

    case AiChat.SET_CHATS: {
      return {
        ...state,
        chats: action.payload,
      };
    }

    case AiChat.ADD_CHAT: {
      return {
        ...state,
        chats: [action.payload, ...state.chats],
      };
    }

    case AiChat.REMOVE_CHAT: {
      return {
        ...state,
        chats: state.chats.filter((c) => c.uuid !== action.payload),
        activeChatUuid: state.activeChatUuid === action.payload ? null : state.activeChatUuid,
        messages: state.activeChatUuid === action.payload ? [] : state.messages,
      };
    }

    case AiChat.SET_ACTIVE_CHAT: {
      return {
        ...state,
        activeChatUuid: action.payload,
        messages: [],
        streamBuffer: '',
        error: null,
      };
    }

    case AiChat.SET_MESSAGES: {
      return {
        ...state,
        messages: action.payload,
      };
    }

    case AiChat.ADD_MESSAGE: {
      return {
        ...state,
        messages: [...state.messages, action.payload],
      };
    }

    case AiChat.SET_STREAMING: {
      return {
        ...state,
        isStreaming: action.payload,
        streamBuffer: action.payload ? '' : state.streamBuffer,
      };
    }

    case AiChat.APPEND_STREAM_CHUNK: {
      return {
        ...state,
        streamBuffer: state.streamBuffer + action.payload,
      };
    }

    case AiChat.FINALIZE_STREAM: {
      return {
        ...state,
        isStreaming: false,
        streamBuffer: '',
        messages: [...state.messages, action.payload],
      };
    }

    case AiChat.SET_ERROR: {
      return {
        ...state,
        error: action.payload,
        isStreaming: false,
      };
    }

    case AiChat.CLEAR_ERROR: {
      return {
        ...state,
        error: null,
      };
    }

    case AiChat.UPDATE_CHAT_TITLE: {
      return {
        ...state,
        chats: state.chats.map((c) =>
          c.uuid === action.payload.chatUuid ? { ...c, title: action.payload.title } : c,
        ),
      };
    }

    default: {
      return state;
    }
  }
}
